import type { Product } from '@/components/Product/ProductCard';
import type { BestsellerProduct } from './types';

function toProductCardImageList(images: string[]): string[] {
  return [...images];
}

export function toProduct(product: BestsellerProduct): Product {
  const productImages = toProductCardImageList(
    [product.productImage, ...(product.productImages || [])].filter(Boolean),
  );
  const productGrayImages = toProductCardImageList(
    (product.productGrayImages || []).filter(Boolean),
  );
  const materialImages = toProductCardImageList((product.materialImages || []).filter(Boolean));
  const celebrityImages = (
    product.celebrityImages || (product.modelImage ? [product.modelImage] : [])
  ).filter(Boolean);
  const baseImage = {
    product_gray: productGrayImages,
    product: productImages,
    material: materialImages,
    celebrity: toProductCardImageList(celebrityImages),
  };
  const fallbackPriceInfo = [
    {
      currency: 'USD',
      price: product.originPriceValue,
      sell_price: product.priceValue,
    },
  ];
  const priceInfo = product.priceInfo?.length
    ? product.priceInfo
    : product.priceInfoPc?.length
      ? product.priceInfoPc
      : product.priceInfoWap?.length
        ? product.priceInfoWap
        : product.priceInfoV0?.length
          ? product.priceInfoV0
          : fallbackPriceInfo;
  const correlation = product.correlation ?? [];

  return {
    id: product.id,
    shop_sku: product.shopSku,
    business_sku: product.businessSku || product.shopSku,
    sku: product.productSku || product.shopSku,
    short_name: product.shortName,
    name: product.description,
    products_category: product.productClassName,
    is_glass: product.isGlass ?? 1,
    is_wish: product.isWish ?? 2,
    wish_num: product.wishNum ?? 0,
    status: product.status ?? 1,
    stock: product.stock ?? 100,
    in_stock: product.inStock ?? 3,
    image: baseImage,
    price_info: priceInfo,
    ...(product.priceInfoV0?.length ? { price_info_v0: product.priceInfoV0 } : {}),
    ...(product.priceInfoV1?.length ? { price_info_v1: product.priceInfoV1 } : {}),
    ...(product.priceInfoV2?.length ? { price_info_v2: product.priceInfoV2 } : {}),
    ...(product.priceInfoV3?.length ? { price_info_v3: product.priceInfoV3 } : {}),
    ...(product.priceInfoPc?.length ? { price_info_pc: product.priceInfoPc } : {}),
    ...(product.priceInfoPcV0?.length ? { price_info_pc_v0: product.priceInfoPcV0 } : {}),
    ...(product.priceInfoPcV1?.length ? { price_info_pc_v1: product.priceInfoPcV1 } : {}),
    ...(product.priceInfoPcV2?.length ? { price_info_pc_v2: product.priceInfoPcV2 } : {}),
    ...(product.priceInfoPcV3?.length ? { price_info_pc_v3: product.priceInfoPcV3 } : {}),
    ...(product.priceInfoWap?.length ? { price_info_wap: product.priceInfoWap } : {}),
    ...(product.priceInfoWapV0?.length ? { price_info_wap_v0: product.priceInfoWapV0 } : {}),
    ...(product.priceInfoWapV1?.length ? { price_info_wap_v1: product.priceInfoWapV1 } : {}),
    ...(product.priceInfoWapV2?.length ? { price_info_wap_v2: product.priceInfoWapV2 } : {}),
    ...(product.priceInfoWapV3?.length ? { price_info_wap_v3: product.priceInfoWapV3 } : {}),
    ...(product.discountPercentV0 !== undefined
      ? { discount_percent_v0: product.discountPercentV0 }
      : {}),
    ...(product.discountPercentV1 !== undefined
      ? { discount_percent_v1: product.discountPercentV1 }
      : {}),
    ...(product.discountPercentV2 !== undefined
      ? { discount_percent_v2: product.discountPercentV2 }
      : {}),
    ...(product.discountPercentV3 !== undefined
      ? { discount_percent_v3: product.discountPercentV3 }
      : {}),
    spu_review_stars: product.rating,
    display_color_num: correlation.length,
    correlation: correlation as Product['correlation'],
  } as Product;
}
